<template>
    <div class="vacancies">
        <div class="row">
            <div class="vacancies__filters-container col-default-12"
                :class="{'vacancies__filters-container--open': isFiltersChanged}"
            >
                <div class="vacancies__filters">
                    <div class="vacancies__search-input vacancies__filters-item col-default-12">
                        <z-input
                            class="vacancies__filters-item"
                            @input="selectName"
                            :value="params.name"
                            :placeholder="text.filters.title"
                            name="name"
                        />
                        <z-icon
                            name="magnifying_glass"
                            dir="top"
                            width="24"
                            height="24"
                        ></z-icon>
                    </div>
                    <z-select
                        class="vacancies__filters-item col-default-4 col-tablet-12"
                        @change="selectCity"
                        :data="cityFilter"
                        :value="params.city"
                        :placeholder="text.filters.city"
                        :disabled="!!params.name"
                    />
                    <z-select
                        class="vacancies__filters-item col-default-4 col-tablet-12"
                        @change="selectSpecialization"
                        :data="specializationFilter"
                        :value="params.specialization"
                        :placeholder="text.filters.specialization"
                        :disabled="!!params.name"
                    />
                    <z-select
                        class="vacancies__filters-item col-default-4 col-tablet-12"
                        @change="selectJobType"
                        :data="jobTypeFilter"
                        :value="params.type"
                        :placeholder="text.filters.jobType"
                        :disabled="!!params.name"
                    />
                </div>

                <button
                    v-if="isFiltersChanged"
                    class="vacancies__filters-clear"
                    @click="clearFilters"
                >
                    {{ text.filters.reset }}
                </button>
            </div>

            <z-caption
                v-if="isFiltersChanged"
                tag="p"
                size="xs"
                class="vacancies__count col-default-12"
                >{{ text.count }} {{ nav.count }}</z-caption
            >
            <div class="vacancies__preloader-wrapper">
                <z-preloader v-if="loading"></z-preloader>
            </div>

            <div v-if="vacancies.length" class="col-default-12">

                <vacancies-card v-for="(vacancyCard, index) in vacancies" :key="index" :vacancyInfo="vacancyCard" />

                <z-pagination
                    @change="loadAnotherPage"
                    class="vacancies__pagination"
                    show-next
                    show-prev
                    :data="{
                        currentPage: nav.current,
                        totalItems: nav.count,
                        totalPages: nav.total,
                        pageRange: 1
                    }"
                />
            </div>

            <z-not-found v-else>
                <template>
                    <z-caption class="vacancies__title vacancies__title--not-found" tag="h2">
                        {{ text.notFound.title }}
                    </z-caption>
                    <z-caption class="vacancies__text" tag="p">
                        {{ text.notFound.text }}
                    </z-caption>
                </template>
            </z-not-found>
        </div>
    </div>
</template>

<script>
import { getVacancies } from '@/api/vacancies'
import { debounce } from 'throttle-debounce'
import VacanciesCard from './VacanciesCard.vue'
import { text } from './constans'
import { showNotyfications } from '@/utils/notifications'
import { queryString } from '@/utils/queryString'

export default {
    name: 'vacancies',
    components: {
        VacanciesCard
    },
    props: {
        source: {
            type: String,
            default: 'vacancies'
        },
        initial: {
            type: Object
        }
    },

    data () {
        return {
            loading: false,
            params: {
                name: '',
                type: '',
                city: '',
                specialization: '',
                page: 1
            },
            page: 1,
            vacancies: [],
            nav: {},
            filters: {},
            cityFilter: [],
            specializationFilter: [],
            jobTypeFilter: [],
            text
        }
    },

    computed: {
        isFiltersChanged () {
            return this.params.city !== '' ||
                this.params.specialization !== '' ||
                this.params.type !== '' ||
                this.params.name !== ''
        },
        clearEmptyParams () {
            const {page, ...params} = this.params
            params.kind = this.params.type

            Object.keys(params).forEach(function (key, index) {
                if (key === 'date' && !params[key][0]) delete params[key]
                if (Array.isArray(params[key])) {
                    if (!params[key].length) delete params[key]
                } else if (!params[key]) {
                    delete params[key]
                }
            })

            return params
        }
    },

    created () {
        this.updateVacanciesList()
        const {kind, ...initial} = this.initial
        initial.type = kind
        this.params = {...this.params, ...this.initial}
    },

    watch: {
        params: {
            handler () {
                queryString(this.clearEmptyParams)
                this.loadVacancies()
            },
            deep: true
        }
    },

    methods: {
        updateVacanciesList () {
            if (this.$root.app.components[this.source]) {
                this.vacancies = this.$root.app.components[this.source].items
                this.filters = this.$root.app.components[this.source].filter
                this.nav = this.$root.app.components[this.source].nav
                this.cityFilter = this.filters.city
                this.specializationFilter = this.filters.specialization
                this.jobTypeFilter = this.filters.type
            }
        },

        selectCity (selectedCity) {
            this.params.city = selectedCity
        },

        selectName (name) {
            this.params.name = name
            this.params.city = ''
            this.params.specialization = ''
            this.params.type = ''
            this.params.page = 1
        },

        selectSpecialization (selectedSpecialization) {
            this.params.specialization = selectedSpecialization
        },

        selectJobType (selectedJobType) {
            this.params.type = selectedJobType
        },

        clearFilters () {
            this.params.name = ''
            this.params.city = ''
            this.params.specialization = ''
            this.params.type = ''
            this.params.page = 1
        },

        loadAnotherPage (page) {
            this.params.page = page
        },

        loadVacancies: debounce(500, async function () {
            if (this.loading) {
                return
            }

            try {
                this.loading = true

                const result = await getVacancies(this.params)

                this.vacancies = result.items
                this.nav = result.nav
            } catch (error) {
                showNotyfications('Ошибка загрузки', { type: 'error' })
            } finally {
                this.loading = false
            }
        })
    }
}
</script>

<style lang="scss">
.vacancies {
    &__filters-container {
        margin-bottom: $token-spacers-m;
    }

    &__search-input {
        position: relative;

        .z-icon {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translate(0, -75%);
        }
    }

    &__preloader-wrapper {
        width: 100%;
        position: relative;

        .z-preloader {
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
        }
    }

    &__filters {
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-wrap: wrap;

        &-item {
            margin-bottom: $token-spacers-2-xs;
            padding: 0;
        }

        &-item:not(:last-child):not(:first-child) {
            padding-right: $token-spacers-xs;

            @include breakpoint(tablet) {
                padding: 0;
            }
        }

        &-clear {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            outline: none;
            border: none !important;
            background-color: transparent;
            cursor: pointer;
            color: $token-colors-link-default;
        }
    }

    &__count {
        font-size: 18px;
        line-height: 140%;
        color: $token-colors-black-60;
        margin-bottom: $token-spacers-m;
        margin-top: 0 !important;
    }

    &__title {
        margin-bottom: $token-spacers-xs;
        font-size: 32px !important;
        line-height: 130% !important;
        color: $token-colors-link-default !important;
        font-weight: 600 !important;

        @include breakpoint(tablet) {
            font-size: 24px !important;
        }

        @include breakpoint(mobile) {
            font-size: 20px !important;
        }

        &--not-found {
            font-size: 44px !important;
            line-height: 120% !important;
            color: #2f2e34 !important;
            margin-bottom: $token-spacers-s;

            @include breakpoint(tablet) {
                font-size: 24px !important;
            }

            @include breakpoint(mobile) {
                font-size: 20px !important;
            }
        }
    }

    &__text {
        font-weight: 600 !important;
        font-weight: 400 !important;
        font-size: 16px !important;
        line-height: 140% !important;
        color: #303033 !important;

        @media screen and (max-width: 725px) {
            max-width: 250px;
        }

        @include breakpoint(mobile) {
            max-width: 240px !important;
        }
    }

    &__pagination {
        display: flex;
        justify-content: center;
        margin-top: $token-spacers-2-xl;
    }
}
</style>
